import * as React from 'react';
import { PostScheduleViewContext } from '../PostSchedule.controller';
import { Modal } from '../../../../components/containers/Modal';
import { ButtonColorsEnum } from '../../../../constants/button-colors';

export type DeletePostModalViewProps = {
  context: PostScheduleViewContext;
  deleteType: 'Trash' | 'Delete';
  postCount: number;
  onClose: (confirm: boolean) => void;
};

export const DeletePostModalView = (props: DeletePostModalViewProps): JSX.Element => {
  const title = props.postCount === 1 ? `${props.deleteType} Post` : `${props.deleteType} Posts`;
  const contentData = {
    LIST: {
      single:
        'Are you sure you want to remove this Post from your Queue? This will also prevent any future iterations of this Post from being published. Any previously-published iterations will stay archived in your Published Posts.',
      multiple: `Are you sure you want to remove these ${props.postCount} Posts from your Queue? This will also prevent any future iterations of these Posts from being published. Any previously-published iterations will stay archived in your Published Posts.`
    },
    WEEK: {
      single:
        'Are you sure you want to remove this Post from your Queue? This will also prevent any future iterations of this Post from being published. Any previously-published iterations will stay archived in your Published Posts.',
      multiple: `Are you sure you want to remove these ${props.postCount} Posts from your Queue? This will also prevent any future iterations of these Posts from being published. Any previously-published iterations will stay archived in your Published Posts.`
    },
    LIBRARY: {
      single:
        'Are you sure you want to remove this Post from your Library? This will also prevent any future iterations of this Post from being published. Any previously-published iterations will stay archived in your Published Posts.',
      multiple: `Are you sure you want to remove these ${props.postCount} Posts from your Library? This will also prevent any future iterations of this Post from being published. Any previously published iterations will stay archived in your Published Posts.`
    }
  };

  const content = props.postCount === 1 ? contentData[props.context].single : contentData[props.context].multiple;

  return (
    <Modal
      title={title}
      onClose={() => props.onClose(false)}
      showCloseIcon={true}
      primaryButtonColor={ButtonColorsEnum.alert}
      primaryButtonTitle={title}
      primaryButtonAction={() => props.onClose(true)}>
      {content}
    </Modal>
  );
};
